module.exports = __webpack_public_path__ + "534700554a8605cc8636cbc9ce24b245.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-04-harrison-first-day-in-india/boat-with-nigel.jpg
// module id = 567
// module chunks = 0